"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.deviceOrientation = exports.isIpad = exports.isRetina = exports.isHighDensity = exports.isDeviceTablet = exports.mdDown = exports.mdUp = exports.smUp = exports.smDown = void 0;

/**
 * MobileDetect.js
 * @returns {boolean} True if mobile, else false
 */
// mobile
var smDown = function smDown() {
  return window.innerWidth <= 720;
}; // desktop


exports.smDown = smDown;

var smUp = function smUp() {
  return window.innerWidth > 720;
}; // > 1024


exports.smUp = smUp;

var mdUp = function mdUp() {
  return window.innerWidth > 1024;
}; // < 1024


exports.mdUp = mdUp;

var mdDown = function mdDown() {
  return window.innerWidth < 1024;
};

exports.mdDown = mdDown;

var isDeviceTablet = function isDeviceTablet() {
  return window.screen.width >= 414 && window.screen.width <= 1024;
};

exports.isDeviceTablet = isDeviceTablet;

var isHighDensity = function isHighDensity() {
  return window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx),only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3;
};

exports.isHighDensity = isHighDensity;

var isRetina = function isRetina() {
  return (window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches) || window.devicePixelRatio && window.devicePixelRatio >= 2) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
};

exports.isRetina = isRetina;

var isIpad = function isIpad() {
  // Replace this function with global device tablet check.
  return navigator.userAgent.match(/iPad/i) != null;
};

exports.isIpad = isIpad;

var deviceOrientation = function deviceOrientation() {
  if (window.matchMedia('(orientation: portrait)').matches) {
    return 'portrait';
  }

  if (window.matchMedia('(orientation: landscape)').matches) {
    return 'landscape';
  }
}; // is default


exports.deviceOrientation = deviceOrientation;
var _default = smDown;
exports["default"] = _default;